import { Container, Row, Col, Carousel } from "react-bootstrap";

function About() {
  return (
    <>
      <Container className="about">
        <Row className="mb-5">
          <p>
            ScopeWithin is a safe space for inner work and holistic wellness. It
            is rooted in the belief that healing begins when we turn inward.
            That with the right support, space, and presence, we can safely
            reflect and explore the thoughts, patterns, emotions, and stories
            that shape us—and begin to meet ourselves with compassion, care and
            clarity. Here, therapy isn't about fixing; it's about understanding.
            It's a lens into the full spectrum of wellness: the mind, the body,
            and the quiet spaces in between. Whether you're seeking support,
            clarity, or calm, this space is here to hold what's ready to unfold.
            Let's begin together..
          </p>
        </Row>
        <Row className="justify-content-center align-items-center g-4 scope-formula mb-10">
          <Col xs="auto">
            <div className="scope-box">
              Scope
              <br />
              <span>=</span>
              <p>
                viewing closely
                <br />
                (like a telescope)
              </p>
            </div>
          </Col>

          <Col xs="auto" className="formula-symbol">
            +
          </Col>

          <Col xs="auto">
            <div className="scope-box">
              Within
              <br />
              <span>=</span>
              <p>
                inner emotional or
                <br />
                mental landscape
                <br />
                (the inner universe)
              </p>
            </div>
          </Col>

          <Col xs="auto" className="formula-symbol">
            =
          </Col>

          <Col xs="auto">
            <div className="scope-box scope-box-highlight">
              ScopeWithin
              <br />
              <span>=</span>
              <p>
                a lens into
                <br />
                the inner world
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default About;
